import { render } from "./Logged.vue?vue&type=template&id=071ab0d5"
import script from "./Logged.vue?vue&type=script&lang=js"
export * from "./Logged.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__